// extracted by mini-css-extract-plugin
export default {"err":"FormErr_err__1yAWQ","shake":"FormErr_shake__4Y8b3"};